module.exports = __webpack_public_path__ + "img/keitaro-landing-step-7.en.99160b7f.jpg";